import React, { lazy } from 'react';
import Greetings from './components/Greetings';
import LoginPage from './components/login/LoginPage';
import Redirect from './components/common/Redirect';
import { resourcesRegistry } from '@pbac-registry/resources-registry';
import { actionsRegistry } from '@pbac-registry/actions-registry';
import { activePoliciesRegistry } from '@pbac-registry/active-policies-registry';

// Lazy imports
const LegalAndPoliciesLazy = lazy(
  () => import('./components/dashboard/legalAndPolicies')
);
const UpdateLegalAndPoliciesLazy = lazy(
  () => import('./components/dashboard/legalAndPolicies/UpdateLegalPolicy')
);
const SupplierLazy = lazy(
  () => import('./components/dashboard/supplier/SupplierPage')
);
const SupplierEditLazy = lazy(
  () => import('./components/dashboard/supplier/SupplierEdit')
);
const CollectionPageLazy = lazy(
  () => import('./components/dashboard/collection/CollectionPage')
);
const CollectionAddEditLazy = lazy(
  () => import('./components/dashboard/collection/CollectionAddEdit')
);
const WidgetGroupsViewLazy = lazy(
  () => import('./components/dashboard/widgets/WidgetGroupsView')
);
const WidgetGroupAddEditLazy = lazy(
  () => import('./components/dashboard/widgets/WidgetGroupAddEdit')
);
const LandingPagesViewLazy = lazy(
  () => import('./components/dashboard/widgets/landing-pages/LandingPagesView')
);
const LandingPageAddEditLazy = lazy(
  () =>
    import('./components/dashboard/widgets/landing-pages/LandingPageAddEdit')
);
const OrderLazy = lazy(() => import('./components/dashboard/order/OrderTable'));

const OrderDetailsLazy = lazy(
  () => import('./components/dashboard/order/OrderDetails')
);

const BannersViewLazy = lazy(
  () => import('./components/dashboard/banners/BannersView')
);

const BannerAddEditLazy = lazy(
  () => import('./components/dashboard/banners/BannersAddEdit')
);

const FirebaseAdminViewLazy = lazy(
  () => import('./components/dashboard/firebase/FirebaseAdminView')
);

const TaxInvoiceFileUploadPageLazy = lazy(
  () => import('./components/dashboard/taxInvoices/TaxInvoiceFileUploadPage')
);
const TaxInvoiceHomePageLazy = lazy(
  () => import('./components/dashboard/taxInvoices/TaxInvoiceHomePage')
);
const TaxInvoiceFilesPageLazy = lazy(
  () => import('./components/dashboard/taxInvoices/TaxInvoiceFilesPage')
);
const TaxInvoiceFilePageLazy = lazy(
  () => import('./components/dashboard/taxInvoices/TaxInvoiceFilePage')
);
const SupplyTasksLazy = lazy(
  () => import('./components/dashboard/supplyTasks/SupplyTasks')
);
const PriceDeactivationLazy = lazy(
  () => import('./components/dashboard/supplyTasks/PriceDeactivation')
);
const MoveCatalogToCollectionHiddenLazy = lazy(
  () =>
    import('./components/dashboard/supplyTasks/MoveCatalogToCollectionHidden')
);
const MoveCatalogToCollectionQualityHiddenLazy = lazy(
  () =>
    import(
      './components/dashboard/supplyTasks/MoveCatalogToCollectionQualityHidden'
    )
);
const AddCatalogsToCollectionsLazy = lazy(
  () => import('./components/dashboard/supplyTasks/AddCatalogsToCollections')
);
const RemoveCatalogsFromCollectionsLazy = lazy(
  () =>
    import('./components/dashboard/supplyTasks/RemoveCatalogsFromCollections')
);
const SuborderSLAUpdateLazy = lazy(
  () => import('./components/dashboard/supplyTasks/SuborderSLAUpdate')
);
const SubOrderCancelDateUpdateLazy = lazy(
  () => import('./components/dashboard/supplyTasks/SubOrderCancelDateUpdate')
);
const ReviewRatingsLazy = lazy(
  () => import('./components/dashboard/reviewRatings/ReviewRatings')
);
const ReviewRatingsVideosLazy = lazy(
  () => import('./components/dashboard/reviewRatings/ReviewRatingsVideos')
);
const AdminAccessViewLazy = lazy(
  () => import('./components/dashboard/admin/AdminAccessView')
);
const AdminFilesUploadingViewLazy = lazy(
  () => import('./components/dashboard/filesUpload/AdminFilesUploadingView')
);
const PriceExperimentViewLazy = lazy(
  () => import('./components/dashboard/priceExperiment/PriceExperimentView')
);
const PriceExperimentAddEditLazy = lazy(
  () => import('./components/dashboard/priceExperiment/PriceExperimentAddEdit')
);
const AudienceSystemLazy = lazy(
  () => import('./components/dashboard/audienceSystem/AudienceSystem')
);
const MarketingDashboardLazy = lazy(
  () => import('./components/dashboard/marketingDashboard/MarketingDashboard')
);
const BitlyGeneratorLazy = lazy(
  () => import('./components/dashboard/marketingDashboard/BitlyGenerator')
);
const UrlShortenerLazy = lazy(
  () => import('./components/dashboard/marketingDashboard/UrlShortener')
);
const CustomUrlShortenerLazy = lazy(
  () => import('./components/dashboard/marketingDashboard/CustomUrlShortener')
);
const FileUploaderLazy = lazy(
  () => import('./components/dashboard/fileUploader/FileUploader')
);
const TaxonomyProductFileUploadLazy = lazy(
  () =>
    import(
      './components/dashboard/filesUpload/taxonomyProductData/TaxonomyProductFileUpload'
    )
);
const TaxonomyProductFilesLazy = lazy(
  () =>
    import(
      './components/dashboard/filesUpload/taxonomyProductData/TaxonomyProductFiles'
    )
);
const TaxonomyProductFileLazy = lazy(
  () =>
    import(
      './components/dashboard/filesUpload/taxonomyProductData/TaxonomyProductFile'
    )
);
const VisualSearchLazy = lazy(
  () => import('./components/dashboard/VisualSearch/VisualSearch')
);

const AudienceAddEditManualLazy = lazy(
  () => import('./components/dashboard/audienceSystem/AudienceAddEditManual')
);
const AudienceAddEditAutomatedLazy = lazy(
  () => import('./components/dashboard/audienceSystem/AudienceAddEditAutomated')
);

const AppBannerFileUploadLazy = lazy(
  () =>
    import('./components/dashboard/filesUpload/appBanner/AppBannerFileUpload')
);
const AppBannerFilesLazy = lazy(
  () => import('./components/dashboard/filesUpload/appBanner/AppBannerFiles')
);
const AppBannerFileLazy = lazy(
  () => import('./components/dashboard/filesUpload/appBanner/AppBannerFile')
);

const SmsPortalMakeCallsLazy = lazy(
  () => import('./components/dashboard/smsPortal/subviews/MakeCalls')
);

const SubOrderCarrierChangeFileUploadLazy = lazy(
  () =>
    import(
      './components/dashboard/filesUpload/subOrderCarrierChangeFileUpload/SubOrderCarrierChangeFileUpload'
    )
);
const SubOrderCarrierChangeFilesLazy = lazy(
  () =>
    import(
      './components/dashboard/filesUpload/subOrderCarrierChangeFileUpload/SubOrderCarrierChangeFiles'
    )
);
const SubOrderCarrierChangeFileLazy = lazy(
  () =>
    import(
      './components/dashboard/filesUpload/subOrderCarrierChangeFileUpload/SubOrderCarrierChangeFile'
    )
);

const ExcelUploadContainerLazy = lazy(
  () => import('./components/excelUpload/container/ExcelUploadContainer')
);
const ExcelUploadedFilesContainerLazy = lazy(
  () => import('./components/excelUpload/container/ExcelUploadedFilesContainer')
);
const DynamicWebViewLazy = lazy(
  () => import('./components/dashboard/dynamicWebview')
);
const DynamicWebViewNewPageLazy = lazy(
  () => import('./components/dashboard/dynamicWebview/components/webviewEditor')
);

const RuleEngineLazy = lazy(
  () => import('./components/dashboard/ruleEngine/RuleEngine')
);
const RuleEngineCreateLazy = lazy(
  () => import('./components/dashboard/ruleEngine/RuleEngineCreate')
);
const BulkCollectionFileUploadLazy = lazy(
  () =>
    import(
      './components/dashboard/filesUpload/bulkCollection/BulkCollectionFileUpload'
    )
);
const BulkCollectionUploadedFileLazy = lazy(
  () =>
    import(
      './components/dashboard/filesUpload/bulkCollection/BulkCollectionUploadedFile'
    )
);
const BulkCollectionUploadedFilesLazy = lazy(
  () =>
    import(
      './components/dashboard/filesUpload/bulkCollection/BulkCollectionUploadedFiles'
    )
);

const CategoryTreesLazy = lazy(
  () => import('./components/dashboard/CategoryNavigation/CategoryTrees')
);
const CategoryTreesEditorLazy = lazy(
  () => import('./components/dashboard/CategoryNavigation/CategoryTreeEditor')
);
const CLPAdminLazy = lazy(() => import('./components/dashboard/CLPAdmin'));
const TopNavAdminLazy = lazy(
  () => import('./components/dashboard/TopNavAdmin')
);
const SortnFilterLazy = lazy(
  () => import('./components/dashboard/SortnFilter')
);
const IntentDetectionRulesLazy = lazy(
  () =>
    import(
      './components/dashboard/SearchOps/intentDetectionRules/IntentDetectionRules'
    )
);
const AddIntentDetectionRuleLazy = lazy(
  () =>
    import(
      './components/dashboard/SearchOps/intentDetectionRules/AddIntentDetectionRule'
    )
);

const POWProductFileUploadLazy = lazy(
  () =>
    import(
      './components/dashboard/filesUpload/pow_products/POWProductFileUpload'
    )
);
const POWProductUploadedFilesLazy = lazy(
  () =>
    import(
      './components/dashboard/filesUpload/pow_products/POWProductUploadedFiles'
    )
);
const POWProductUploadedFileLazy = lazy(
  () =>
    import(
      './components/dashboard/filesUpload/pow_products/POWProductUploadedFile'
    )
);
const CLPProductsViewLazy = lazy(
  () => import('./components/dashboard/CLPAdmin/CLPProductsView')
);

const HVFAdminPageLazy = lazy(
  () => import('./components/dashboard/HVFAdmin/HVFAdmin')
);
const AddNewFilterGroupLazy = lazy(
  () => import('./components/dashboard/HVFAdmin/addNewFilterGroup')
);
const EditFilterGroupLazy = lazy(
  () => import('./components/dashboard/HVFAdmin/editFilterGroup')
);

const FulfilmentLazy = lazy(() => import('./components/dashboard/fulfilment'));
const ImagesBulkUploadLazy = lazy(
  () =>
    import(
      './components/dashboard/filesUpload/imagesBulkUpload/ImagesBulkUpload'
    )
);

const ServiceabilityFileUploadLazy = lazy(
  () =>
    import(
      './components/dashboard/filesUpload/serviceabilityFileUpload/ServiceabilityFileUpload'
    )
);
const AdsTaskLazy = lazy(
  () => import('./components/dashboard/adsTask/AdsTask')
);
const AdsTaskFileUploadLazy = lazy(
  () => import('./components/dashboard/adsTask/AdsTaskFileUpload')
);
const AdminNoticesLazy = lazy(
  () => import('./components/dashboard/adminNotices/AdminNotices')
);

const TaskCampaignLazy = lazy(
  () => import('./components/dashboard/adsTask/TaskCamapaign')
);

const MMAConsentBannerCreation = lazy(
  () => import('./components/dashboard/MMMLink/MMAConsentBannerCreation')
);

const MMALinkLazy = lazy(() => import('./components/dashboard/MMMLink'));

const TaskStatusLazy = lazy(
  () => import('./components/dashboard/adsTask/TaskStatus')
);

const LiveStreamLazy = lazy(
  () => import('./components/dashboard/liveCommerce/LiveStream')
);

const LiveStreamsLazy = lazy(
  () => import('./components/dashboard/liveCommerce/LiveStreams')
);

const CreateLiveStreamLazy = lazy(
  () => import('./components/dashboard/liveCommerce/CreateLiveStream')
);

const LiveStreamBulkStreamCreationLazy = lazy(
  () =>
    import('./components/dashboard/liveCommerce/LiveStreams/BulkStreamCreation')
);

const LiveStreamBulkStreamUpdationLazy = lazy(
  () =>
    import('./components/dashboard/liveCommerce/LiveStreams/BulkStreamUpdation')
);

const CreateTemplatePresetLazy = lazy(
  () => import('./components/dashboard/liveCommerce/CreateTemplatePreset')
);

const CreateCampaignPresetLazy = lazy(
  () => import('./components/dashboard/liveCommerce/CreateCampaignPreset')
);

const LiveCommerceLazy = lazy(
  () => import('./components/dashboard/liveCommerce/LiveCommerce')
);

const TemplatePresetsLazy = lazy(
  () => import('./components/dashboard/liveCommerce/TemplatePresets')
);

const CampaignPresetsLazy = lazy(
  () => import('./components/dashboard/liveCommerce/CampaignPresets')
);

const CreateRealEstatePresetLazy = lazy(
  () => import('./components/dashboard/liveCommerce/CreateRealEstatePreset')
);

const RealEstatePresetsLazy = lazy(
  () => import('./components/dashboard/liveCommerce/RealEstatePresets')
);

const UpsertBannersLazy = lazy(
  () => import('./components/dashboard/liveCommerce/Banners/UpsertBanners')
);

const BannersLazy = lazy(
  () => import('./components/dashboard/liveCommerce/Banners/Banners')
);

const DiscountsLazy = lazy(
  () => import('./components/dashboard/liveCommerce/Discounts/Discounts')
);

const AddDiscountLazy = lazy(
  () => import('./components/dashboard/liveCommerce/Discounts/AddDiscount')
);

const UploadDiscountLazy = lazy(
  () => import('./components/dashboard/liveCommerce/Discounts/UploadDiscount')
);

const CampaignDashboard = lazy(
  () => import('./components/dashboard/DisplayAds/CampaignDashboard')
);

const DisplayAwareness = lazy(
  () => import('./components/dashboard/DisplayAds/DisplayAwareness')
);

const CreateNewCampaign = lazy(
  () => import('./components/dashboard/DisplayAds/CreateNewCampaign')
);

const NonSellerPortal = lazy(
  () => import('./components/dashboard/NonSellerPortal/SignUp')
);

const POWWhatsAppDashboard = lazy(
  () => import('./components/dashboard/pow/POWWhatsAppDashboard')
);

export const pageRoutes = [
  {
    path: '/',
    component: Greetings,
    skipAuth: true,
    selectedTabPath: '/',

  },
  {
    path: '/login',
    component: LoginPage,
    skipAuth: true,
    selectedTabPath: '/login',
  },
  {
    path: '/suppliers',
    component: SupplierLazy,
    resource: resourcesRegistry.pageSuppliers,
    action: actionsRegistry.actionRead,
    selectedTabPath: '/suppliers',
    attachedPolicies: [activePoliciesRegistry.allowSuppliersLandingPageViewAccess],
  },
  {
    path: '/pow-whatsapp-dashboard',
    component: POWWhatsAppDashboard,
    resource: resourcesRegistry.pagePowWhatsAppDashboard,
    action: actionsRegistry.actionRead,
    selectedTabPath: '/pow-whatsapp-dashboard',
  },
  {
    path: '/supplier/edit/:id',
    component: SupplierEditLazy,
    resource: resourcesRegistry.pageSupplierEditId,
    action: actionsRegistry.actionRead,
    selectedTabPath: '/suppliers',
  },
  {
    path: '/collections',
    component: CollectionPageLazy,
    resource: resourcesRegistry.pageCollections,
    action: actionsRegistry.actionRead,
    selectedTabPath: '/collections',
    attachedPolicies: [activePoliciesRegistry.allowCollectionsLandingPageViewAccess],
  },
  {
    path: '/collection/add-collection',
    component: CollectionAddEditLazy,
    resource: resourcesRegistry.pageCollectionAddCollection,
    action: actionsRegistry.actionRead,
    selectedTabPath: '/collection',
    attachedPolicies: [activePoliciesRegistry.allowAddCollectionPageViewAccess],
  },
  {
    path: '/collection/:id',
    component: () => <Redirect path="/v3/cataloging/collection/:id" />,
    resource: ['collection_view'],
    action: null,
    selectedTabPath: '/collection',
  },
  {
    path: '/collection/edit/:id',
    component: CollectionAddEditLazy,
    resource: resourcesRegistry.pageCollectionId,
    action: actionsRegistry.actionRead,
    selectedTabPath: '/collection',
    attachedPolicies: [activePoliciesRegistry.allowCollectionEditPageViewAccess],
  },
  {
    path: '/widgets-group',
    component: WidgetGroupsViewLazy,
    resource: resourcesRegistry.pageWidgetsGroup,
    action: actionsRegistry.actionRead,
    selectedTabPath: '/widgets-group',
    attachedPolicies: [activePoliciesRegistry.allowWidgetsGroupLandingPageViewAccess],
  },
  {
    path: '/widget-group/add',
    component: WidgetGroupAddEditLazy,
    resource: resourcesRegistry.pageWidgetGroupAdd,
    action: actionsRegistry.actionCreate,
    selectedTabPath: '/widget-group',
    attachedPolicies: [activePoliciesRegistry.allowWidgetsGroupAddWidgetAccess],
  },
  {
    path: '/widget-group/:id',
    component: WidgetGroupAddEditLazy,
    resource: resourcesRegistry.pageWidgetGroupId,
    action: actionsRegistry.actionRead,
    selectedTabPath: '/widget-group',
    attachedPolicies: [activePoliciesRegistry.allowWidgetsGroupWidgetViewAccess],
  },
  {
    path: '/landing-pages',
    component: LandingPagesViewLazy,
    resource: resourcesRegistry.pageLandingPages,
    action: actionsRegistry.actionRead,
    selectedTabPath: '/landing-pages',
    attachedPolicies: [activePoliciesRegistry.allowLandingPageViewAccess],
  },
  {
    path: '/landing-page/add',
    component: LandingPageAddEditLazy,
    resource: resourcesRegistry.pageLandingPageAdd,
    action: actionsRegistry.actionCreate,
    selectedTabPath: '/landing-page',
    attachedPolicies: [activePoliciesRegistry.allowLandingPageCreateAccess],
  },
  {
    path: '/landing-page/:id',
    component: LandingPageAddEditLazy,
    resource: resourcesRegistry.pageLandingPageId,
    action: actionsRegistry.actionRead,
    selectedTabPath: '/landing-page',
    attachedPolicies: [activePoliciesRegistry.allowLandingPageEditAccess],
  },
  {
    path: '/orders',
    component: OrderLazy,
    resource: resourcesRegistry.pageOrders,
    action: actionsRegistry.actionRead,
    selectedTabPath: '/orders',
    attachedPolicies: [activePoliciesRegistry.allowOrdersPageViewAccess],
  },
  {
    path: '/orders/:page_number',
    component: OrderLazy,
    resource: resourcesRegistry.pageOrdersPageNumber,
    action: actionsRegistry.actionRead,
    selectedTabPath: '/orders',
  },
  {
    path: '/order/:id',
    component: OrderDetailsLazy,
    resource: resourcesRegistry.pageOrderDetails,
    action: actionsRegistry.actionRead,
    selectedTabPath: '/orders',
    attachedPolicies: [activePoliciesRegistry.allowOrderDetailsPageViewAccess],
  },
  {
    path: '/tax-invoices',
    component: TaxInvoiceHomePageLazy,
    resource: resourcesRegistry.pageTaxInvoices,
    action: actionsRegistry.actionRead,
    selectedTabPath: '/tax-invoices',
    attachedPolicies: [activePoliciesRegistry.allowTaxInvoicesAccess],
  },
  {
    path: '/tax-invoices/:gstType',
    component: TaxInvoiceFileUploadPageLazy,
    resource: resourcesRegistry.pageTaxInvoicesGstType,
    action: actionsRegistry.actionRead,
    selectedTabPath: '/tax-invoices',
  },
  {
    path: '/tax-invoices/files',
    component: TaxInvoiceFilesPageLazy,
    resource: resourcesRegistry.pageTaxInvoicesFiles,
    action: actionsRegistry.actionRead,
    selectedTabPath: '/tax-invoices',
  },
  {
    path: '/tax-invoices/file/:id',
    component: TaxInvoiceFilePageLazy,
    resource: resourcesRegistry.pageTaxInvoicesFileId,
    action: actionsRegistry.actionRead,
    selectedTabPath: '/tax-invoices',
  },
  {
    path: '/app-banners',
    component: BannersViewLazy,
    resource: resourcesRegistry.pageAppBanners,
    action: actionsRegistry.actionRead,
    selectedTabPath: '/app-banners',
    attachedPolicies: [activePoliciesRegistry.allowAppBannersViewAccess],
  },
  {
    path: '/banner/add',
    component: BannerAddEditLazy,
    resource: resourcesRegistry.pageBannerAdd,
    action: actionsRegistry.actionRead,
    selectedTabPath: '/app-banners',
    attachedPolicies: [activePoliciesRegistry.allowAppBannersAddAccess],
  },
  {
    path: '/banner/:id',
    component: BannerAddEditLazy,
    resource: resourcesRegistry.pageBannerId,
    action: actionsRegistry.actionRead,
    selectedTabPath: '/app-banners',
  },
  {
    path: '/supply-tasks',
    component: SupplyTasksLazy,
    resource: resourcesRegistry.pageSupplyTasks,
    action: actionsRegistry.actionRead,
    selectedTabPath: '/supply-tasks',
    attachedPolicies: [activePoliciesRegistry.allowSupplyTasksLandingPageViewAcess],
  },
  {
    path: '/supply-tasks/catalog-hidden',
    component: PriceDeactivationLazy,
    resource: resourcesRegistry.pageSupplyTasksCatalogHidden,
    action: actionsRegistry.actionRead,
    selectedTabPath: '/supply-tasks',
    attachedPolicies: [activePoliciesRegistry.allowSupplyTasksCatalogHiddenAccess],
  },
  {
    path: '/supply-tasks/move-catalog-to-collection-hidden',
    component: MoveCatalogToCollectionHiddenLazy,
    resource: resourcesRegistry.pageSupplyTasksMoveCatalogToCollectionHidden,
    action: actionsRegistry.actionRead,
    selectedTabPath: '/supply-tasks',
    attachedPolicies: [activePoliciesRegistry.allowSupplyTasksMoveCatalogsToHiddenCollectionAccess],
  },
  {
    path: '/supply-tasks/move-catalogs-to-quality-hidden-collection',
    component: MoveCatalogToCollectionQualityHiddenLazy,
    resource:
      resourcesRegistry.pageSupplyTasksMoveCatalogsToQualityHiddenCollection,
    action: actionsRegistry.actionRead,
    selectedTabPath: '/supply-tasks',
    attachedPolicies: [activePoliciesRegistry.allowSupplyTasksMoveCatalogsToQualityHiddenCollectionAccess],
  },
  {
    path: '/supply-tasks/add-catalogs-to-collections',
    component: AddCatalogsToCollectionsLazy,
    resource: resourcesRegistry.pageSupplyTasksAddCatalogsToCollections,
    action: actionsRegistry.actionRead,
    selectedTabPath: '/supply-tasks',
    attachedPolicies: [activePoliciesRegistry.allowSupplyTasksAddCatalogsToCollectionAccess],
  },
  {
    path: '/supply-tasks/remove-catalogs-from-collections',
    component: RemoveCatalogsFromCollectionsLazy,
    resource: resourcesRegistry.pageSupplyTasksRemoveCatalogsFromCollections,
    action: actionsRegistry.actionRead,
    selectedTabPath: '/supply-tasks',
  },
  {
    path: '/supply-tasks/suborder-sla-update',
    component: SuborderSLAUpdateLazy,
    resource: resourcesRegistry.pageSupplyTasksSuborderSlaUpdate,
    action: actionsRegistry.actionRead,
    selectedTabPath: '/supply-tasks',
    attachedPolicies: [activePoliciesRegistry.allowSupplyTasksSuborderSlaUpdateAccess],
  },
  {
    path: '/supply-tasks/suborder-cancel-date-update',
    component: SubOrderCancelDateUpdateLazy,
    resource: resourcesRegistry.pageSupplyTasksSuborderCancelDateUpdate,
    action: actionsRegistry.actionRead,
    selectedTabPath: '/supply-tasks',
    attachedPolicies: [activePoliciesRegistry.allowSupplyTasksSuborderCancelDateUpdateAccess],
  },
  {
    path: '/review-ratings',
    component: ReviewRatingsLazy,
    resource: resourcesRegistry.pageReviewRatings,
    action: actionsRegistry.actionRead,
    selectedTabPath: '/review-ratings',
    attachedPolicies: [activePoliciesRegistry.allowReviewRatingsAccess],
  },
  {
    path: '/review-ratings/videos',
    component: ReviewRatingsVideosLazy,
    resource: resourcesRegistry.pageReviewRatingsVideos,
    action: actionsRegistry.actionRead,
    selectedTabPath: '/review-ratings',
  },
  {
    path: '/review-ratings/videos/:page_number',
    component: ReviewRatingsVideosLazy,
    resource: resourcesRegistry.pageReviewRatingsVideosPageNumber,
    action: actionsRegistry.actionRead,
    selectedTabPath: '/review-ratings',
  },
  {
    path: '/review-ratings/:page_number',
    component: ReviewRatingsLazy,
    resource: resourcesRegistry.pageReviewRatingsPageNumber,
    action: actionsRegistry.actionRead,
    selectedTabPath: '/review-ratings',
  },
  {
    path: '/dynamic-webview',
    component: DynamicWebViewLazy,
    resource: resourcesRegistry.pageDynamicWebview,
    action: actionsRegistry.actionRead,
    selectedTabPath: '/dynamic-webview',
    attachedPolicies: [activePoliciesRegistry.allowDynamicWebviewLandingPageAccess],
  },
  {
    path: '/dynamic-webview/editor/:pageId',
    component: DynamicWebViewNewPageLazy,
    resource: resourcesRegistry.pageDynamicWebviewEditorId,
    action: actionsRegistry.actionRead,
    selectedTabPath: '/dynamic-webview',
    attachedPolicies: [activePoliciesRegistry.allowDynamicWebviewsEditAccess],
  },
  {
    path: '/firebase/admin',
    component: FirebaseAdminViewLazy,
    resource: resourcesRegistry.pageFirebaseAdmin,
    action: actionsRegistry.actionRead,
    selectedTabPath: '/firebase',
    attachedPolicies: [activePoliciesRegistry.allowFirebaseAdminLandingPageViewAccess],
  },
  {
    path: '/admin-access',
    component: AdminAccessViewLazy,
    resource: resourcesRegistry.pageAdminAccess,
    action: actionsRegistry.actionRead,
    selectedTabPath: '/admin-access',
  },
  {
    path: '/files-uploading',
    component: AdminFilesUploadingViewLazy,
    resource: resourcesRegistry.pageFilesUploading,
    action: actionsRegistry.actionRead,
    selectedTabPath: '/files-uploading',
  },
  {
    path: '/visual-search',
    component: VisualSearchLazy,
    resource: resourcesRegistry.pageVisualSearch,
    action: actionsRegistry.actionRead,
    selectedTabPath: '/visual-search',
  },
  {
    path: '/marketing-dashboard',
    component: MarketingDashboardLazy,
    resource: resourcesRegistry.pageMarketingDashboard,
    action: actionsRegistry.actionRead,
    selectedTabPath: '/marketing-dashboard',
    attachedPolicies: [activePoliciesRegistry.allowMarketingDashboardLandingPageViewAccess],
  },
  {
    path: '/marketing-dashboard/bitly-generator',
    component: BitlyGeneratorLazy,
    resource: resourcesRegistry.pageMarketingDashboardBitlyGenerator,
    action: actionsRegistry.actionRead,
    selectedTabPath: '/marketing-dashboard',
    attachedPolicies: [activePoliciesRegistry.allowMarketingDashboardBitlyGeneratorViewAccess],
  },
  {
    path: '/marketing-dashboard/url-shortener',
    component: UrlShortenerLazy,
    resource: resourcesRegistry.pageMarketingDashboardUrlShortener,
    action: actionsRegistry.actionRead,
    selectedTabPath: '/marketing-dashboard',
    attachedPolicies: [activePoliciesRegistry.allowMarketingDashboardUrlShortnerViewAccess],
  },
  {
    path: '/marketing-dashboard/custom-url-shortener',
    component: CustomUrlShortenerLazy,
    resource: resourcesRegistry.pageMarketingDashboardCustomUrlShortener,
    action: actionsRegistry.actionRead,
    selectedTabPath: '/marketing-dashboard',
    attachedPolicies: [activePoliciesRegistry.allowMarketingDashboardCustomUrlShorternerViewAccess],
  },
  {
    path: '/s3-file-uploader',
    component: FileUploaderLazy,
    resource: resourcesRegistry.pageS3FileUploader,
    action: actionsRegistry.actionRead,
    selectedTabPath: '/s3-file-uploader',
    attachedPolicies: [activePoliciesRegistry.allowS3FileUploaderViewAccess],
  },
  {
    path: '/taxonomy-product-file-upload',
    component: TaxonomyProductFileUploadLazy,
    resource: resourcesRegistry.pageTaxonomyProductFileUpload,
    action: actionsRegistry.actionRead,
    selectedTabPath: '/taxonomy-product-file-upload',
    attachedPolicies: [activePoliciesRegistry.allowTaxonomyFileUploadAccess],
  },
  {
    path: '/taxonomy-product-file-upload/files',
    component: TaxonomyProductFilesLazy,
    resource: resourcesRegistry.pageTaxonomyProductFileUploadFiles,
    action: actionsRegistry.actionRead,
    selectedTabPath: '/taxonomy-product-file-upload',
    attachedPolicies: [activePoliciesRegistry.allowTaxonomyFilesUploadedViewAccess],
  },
  {
    path: '/taxonomy-product-file-upload/file/:id',
    component: TaxonomyProductFileLazy,
    resource: resourcesRegistry.pageTaxonomyProductFileUploadFileId,
    action: actionsRegistry.actionRead,
    selectedTabPath: '/taxonomy-product-file-upload',
    attachedPolicies: [activePoliciesRegistry.allowTaxonomyFilesUploadedViewAccess],
  },
  {
    path: '/ab-experiment',
    component: PriceExperimentViewLazy,
    resource: resourcesRegistry.pageAbExperiment,
    action: actionsRegistry.actionRead,
    selectedTabPath: '/ab-experiment',
    attachedPolicies: [activePoliciesRegistry.allowAbExperimentPageAccess],
  },
  {
    path: '/ab-experiment/add',
    component: PriceExperimentAddEditLazy,
    resource: resourcesRegistry.pageAbExperimentAdd,
    action: actionsRegistry.actionRead,
    selectedTabPath: '/ab-experiment',
  },
  {
    path: '/ab-experiment/:id',
    component: PriceExperimentAddEditLazy,
    resource: resourcesRegistry.pageAbExperimentId,
    action: actionsRegistry.actionRead,
    selectedTabPath: '/ab-experiment',
  },
  {
    path: '/audience-system',
    component: AudienceSystemLazy,
    resource: resourcesRegistry.pageAudienceSystem,
    action: actionsRegistry.actionRead,
    selectedTabPath: '/audience-system',
  },
  {
    path: '/audience-system/add-manual',
    component: AudienceAddEditManualLazy,
    resource: resourcesRegistry.pageAudienceSystemAddManual,
    action: actionsRegistry.actionRead,
    selectedTabPath: '/audience-system',
  },
  {
    path: '/audience-system/edit-manual/:id',
    component: AudienceAddEditManualLazy,
    resource: resourcesRegistry.pageAudienceSystemEditManualId,
    action: actionsRegistry.actionRead,
    selectedTabPath: '/audience-system',
  },
  {
    path: '/audience-system/add-automated',
    component: AudienceAddEditAutomatedLazy,
    resource: resourcesRegistry.pageAudienceSystemAddAutomated,
    action: actionsRegistry.actionRead,
    selectedTabPath: '/audience-system',
  },
  {
    path: '/audience-system/edit-automated/:id',
    component: AudienceAddEditAutomatedLazy,
    resource: resourcesRegistry.pageAudienceSystemEditAutomatedId,
    action: actionsRegistry.actionRead,
    selectedTabPath: '/audience-system',
  },
  {
    path: '/make-calls',
    component: SmsPortalMakeCallsLazy,
    resource: resourcesRegistry.pageMakeCalls,
    action: actionsRegistry.actionRead,
    selectedTabPath: '/make-calls',
    attachedPolicies: [activePoliciesRegistry.allowMakeCallsAccess],
  },
  {
    path: '/app-banner-file-upload',
    component: AppBannerFileUploadLazy,
    resource: resourcesRegistry.pageAppBannerFileUpload,
    action: actionsRegistry.actionRead,
    selectedTabPath: '/app-banner-file-upload',
    attachedPolicies: [activePoliciesRegistry.allowAppBannerFileUploadAccess],
  },
  {
    path: '/app-banner-file-upload/files',
    component: AppBannerFilesLazy,
    resource: resourcesRegistry.pageAppBannerFileUploadFiles,
    action: actionsRegistry.actionRead,
    selectedTabPath: '/app-banner-file-upload',
    attachedPolicies: [activePoliciesRegistry.allowAppBannerUploadedFilesViewAccess],
  },
  {
    path: '/app-banner/file/:id',
    component: AppBannerFileLazy,
    resource: resourcesRegistry.pageAppBannerFileUploadFileId,
    action: actionsRegistry.actionRead,
    selectedTabPath: '/app-banner-file-upload',
    attachedPolicies: [activePoliciesRegistry.allowAppBannerUploadedFilesViewAccess],
  },
  {
    path: '/sub-order-carrier-change',
    component: SubOrderCarrierChangeFileUploadLazy,
    resource: resourcesRegistry.pageSubOrderCarrierChange,
    action: actionsRegistry.actionRead,
    selectedTabPath: '/sub-order-carrier-change',
    attachedPolicies: [activePoliciesRegistry.allowSubOrderCarrierChangeFileUploadAccess],
  },
  {
    path: '/sub-order-carrier-change/files',
    component: SubOrderCarrierChangeFilesLazy,
    resource: resourcesRegistry.pageSubOrderCarrierChangeFiles,
    action: actionsRegistry.actionRead,
    selectedTabPath: '/sub-order-carrier-change',
    attachedPolicies: [activePoliciesRegistry.allowSubOrderCarrierChangeUploadedFilesViewAccess],
  },
  {
    path: '/sub-order-carrier-change/file/:id',
    component: SubOrderCarrierChangeFileLazy,
    resource: resourcesRegistry.pageSubOrderCarrierChangeFileId,
    action: actionsRegistry.actionRead,
    selectedTabPath: '/sub-order-carrier-change',
    attachedPolicies: [activePoliciesRegistry.allowSubOrderCarrierChangeUploadedFilesViewAccess],
  },
  {
    path: '/bulk-collection-file-upload',
    component: BulkCollectionFileUploadLazy,
    resource: resourcesRegistry.pageBulkCollectionFileUpload,
    action: actionsRegistry.actionRead,
    selectedTabPath: '/bulk-collection-file-upload',
    attachedPolicies: [activePoliciesRegistry.allowBulkCollectionFileUploadAccess],
  },
  {
    path: '/bulk-collection-file-upload/files',
    component: BulkCollectionUploadedFilesLazy,
    resource: resourcesRegistry.pageBulkCollectionFileUploadFiles,
    action: actionsRegistry.actionRead,
    selectedTabPath: '/bulk-collection-file-upload',
    attachedPolicies: [activePoliciesRegistry.allowBulkCollectionUploadedFilesViewAccess],
  },
  {
    path: '/bulk-collection-file-upload/file/:id',
    component: BulkCollectionUploadedFileLazy,
    resource: resourcesRegistry.pageBulkCollectionFileUploadFileId,
    action: actionsRegistry.actionRead,
    selectedTabPath: '/bulk-collection-file-upload',
    attachedPolicies: [activePoliciesRegistry.allowBulkCollectionUploadedFilesViewAccess],
  },
  {
    path: '/excel-upload',
    component: ExcelUploadContainerLazy,
    resource: resourcesRegistry.pageExcelUpload,
    action: actionsRegistry.actionRead,
    selectedTabPath: '/excel-upload',
  },
  {
    path: '/excel-upload/files',
    component: ExcelUploadedFilesContainerLazy,
    resource: resourcesRegistry.pageExcelUploadFiles,
    action: actionsRegistry.actionRead,
    selectedTabPath: '/excel-upload',
  },
  {
    path: '/rule-engine',
    component: RuleEngineLazy,
    resource: resourcesRegistry.pageRuleEngine,
    action: actionsRegistry.actionRead,
    selectedTabPath: '/rule-engine',
    attachedPolicies: [activePoliciesRegistry.allowRuleEngineLandingPageViewAccess],
  },
  {
    path: '/rule-engine/create/:ruleId',
    component: RuleEngineCreateLazy,
    resource: resourcesRegistry.pageRuleEngineCreateId,
    action: actionsRegistry.actionRead,
    selectedTabPath: '/rule-engine',
    attachedPolicies: [activePoliciesRegistry.allowRuleEngineAddAndEditAccess],
  },
  {
    path: '/search-ops/intent-detection-rule',
    component: IntentDetectionRulesLazy,
    resource: resourcesRegistry.pageSearchOpsIntentDetectionRule,
    action: actionsRegistry.actionRead,
    selectedTabPath: '/v3/discovery/search-ops',
  },
  {
    path: '/search-ops/intent-detection-rule/add',
    component: AddIntentDetectionRuleLazy,
    resource: resourcesRegistry.pageSearchOpsIntentDetectionRule,
    action: actionsRegistry.actionCreate,
    selectedTabPath: '/v3/discovery/search-ops',
  },
  {
    path: '/search-ops/intent-detection-rule/:id',
    component: AddIntentDetectionRuleLazy,
    resource: resourcesRegistry.pageSearchOpsIntentDetectionRule,
    action: actionsRegistry.actionUpdate,
    selectedTabPath: '/v3/discovery/search-ops',
  },
  {
    path: '/images-bulk-upload',
    component: ImagesBulkUploadLazy,
    resource: resourcesRegistry.pageImagesBulkUpload,
    action: actionsRegistry.actionRead,
    selectedTabPath: '/images-bulk-upload',
    attachedPolicies: [activePoliciesRegistry.allowImagesBulkUploadAccess],
  },
  {
    path: '/category-navigation',
    component: CategoryTreesLazy,
    resource: resourcesRegistry.pageCategoryNavigation,
    action: actionsRegistry.actionRead,
    selectedTabPath: '/category-navigation',
    attachedPolicies: [activePoliciesRegistry.allowCategoryNavigationViewAccess, activePoliciesRegistry.allowCategoryNavigationAddAndCloneAccess],
  },
  {
    path: '/category-navigation/editor/:treeId',
    component: CategoryTreesEditorLazy,
    resource: resourcesRegistry.pageCategoryNavigationTreesEditor,
    action: actionsRegistry.actionRead,
    selectedTabPath: '/category-navigation',
    attachedPolicies: [activePoliciesRegistry.allowCategoryNavigationEditAccess],
  },
  {
    path: '/clp-admin',
    component: CLPAdminLazy,
    resource: resourcesRegistry.pageClpAdmin,
    action: actionsRegistry.actionRead,
    selectedTabPath: '/clp-admin',
    attachedPolicies: [activePoliciesRegistry.allowClpAdminAccess],
  },
  {
    path: '/top-nav-admin',
    component: TopNavAdminLazy,
    resource: resourcesRegistry.pageTopNavAdmin,
    action: actionsRegistry.actionRead,
    selectedTabPath: '/top-nav-admin',
    attachedPolicies: [activePoliciesRegistry.allowTopNavAdminAccess],
  },
  {
    path: '/sort-and-filter',
    component: SortnFilterLazy,
    resource: resourcesRegistry.pageSortAndFilter,
    action: actionsRegistry.actionRead,
    selectedTabPath: '/sort-and-filter',
    attachedPolicies: [activePoliciesRegistry.allowSortAndFilterAccess],
  },
  {
    path: '/pow-products-file-upload',
    component: POWProductFileUploadLazy,
    resource: resourcesRegistry.pagePowProductsFileUpload,
    action: actionsRegistry.actionRead,
    selectedTabPath: '/pow-products-file-upload',
    attachedPolicies: [activePoliciesRegistry.allowPowProductsFileUploadAccess],
  },
  {
    path: '/pow-products-file-upload/files',
    component: POWProductUploadedFilesLazy,
    resource: resourcesRegistry.pagePowProductsFileUploadFiles,
    action: actionsRegistry.actionRead,
    selectedTabPath: '/pow-products-file-upload',
    attachedPolicies: [activePoliciesRegistry.allowPowProductsUploadedFilesViewAccess],
  },
  {
    path: '/pow-products-file-upload/file/:id',
    component: POWProductUploadedFileLazy,
    resource: resourcesRegistry.pagePowProductsFileUploadFileId,
    action: actionsRegistry.actionRead,
    selectedTabPath: '/pow-products-file-upload',
    attachedPolicies: [activePoliciesRegistry.allowPowProductsUploadedFilesViewAccess],
  },
  {
    path: '/clp/products',
    component: CLPProductsViewLazy,
    resource: resourcesRegistry.pageClpProducts,
    action: actionsRegistry.actionRead,
    selectedTabPath: '/clp',
    attachedPolicies: [activePoliciesRegistry.allowClpFiltersValidationAccess],
  },
  {
    path: '/hvf-admin',
    component: HVFAdminPageLazy,
    resource: resourcesRegistry.pageHvfAdmin,
    action: actionsRegistry.actionRead,
    selectedTabPath: '/hvf-admin',
    attachedPolicies: [activePoliciesRegistry.allowHvfAdminLandingPageViewAndIsValidUpdateAccess],
  },
  {
    path: '/hvf-admin/add-new-filter-group',
    component: AddNewFilterGroupLazy,
    resource: resourcesRegistry.pageHvfAdminAddNewFilterGroup,
    action: actionsRegistry.actionRead,
    selectedTabPath: '/hvf-admin',
    attachedPolicies: [activePoliciesRegistry.allowHvfAdminAddFilterGroupAccess],
  },
  {
    path: '/hvf-admin/edit-filter-group',
    component: EditFilterGroupLazy,
    resource: resourcesRegistry.pageHvfAdminEditFilterGroup,
    action: actionsRegistry.actionRead,
    selectedTabPath: '/hvf-admin',
    attachedPolicies: [activePoliciesRegistry.allowHvfAdminEditFilterGroupAccess],
  },
  {
    path: '/fulfilment',
    component: FulfilmentLazy,
    resource: resourcesRegistry.pageFulfilment,
    action: actionsRegistry.actionRead,
    selectedTabPath: '/fulfilment',
    attachedPolicies: [activePoliciesRegistry.allowReturnReasonsFulfimentAccess],
  },
  {
    path: '/serviceability-file-upload',
    component: ServiceabilityFileUploadLazy,
    resource: resourcesRegistry.pageServiceabilityFileUpload,
    action: actionsRegistry.actionRead,
    selectedTabPath: '/serviceability-file-upload',
    attachedPolicies: [activePoliciesRegistry.allowServiceabilityFileUploadAccess],
  },
  {
    path: '/admin-notices',
    component: AdminNoticesLazy,
    resource: resourcesRegistry.pageAdminNotices,
    action: actionsRegistry.actionRead,
    selectedTabPath: '/admin-notices',
    attachedPolicies: [activePoliciesRegistry.allowAdminNoticesPageViewAccess],
  },
  {
    path: '/legal-and-policies',
    component: LegalAndPoliciesLazy,
    resource: resourcesRegistry.pageLegalAndPolicies,
    action: actionsRegistry.actionRead,
    selectedTabPath: '/legal-and-policies',
    attachedPolicies: [activePoliciesRegistry.allowLegalAndPoliciesViewAccess],
  },
  {
    path: '/legal-and-policies/policy/:policy_id',
    component: UpdateLegalAndPoliciesLazy,
    resource: resourcesRegistry.pageLegalAndPolicies,
    action: actionsRegistry.actionRead,
    selectedTabPath: '/legal-and-policies',
  },
  {
    path: '/ads-task',
    component: AdsTaskLazy,
    resource: resourcesRegistry.pageAdsTask,
    action: actionsRegistry.actionRead,
    selectedTabPath: '/ads-task',
  },
  {
    path: '/ads-task/add',
    component: AdsTaskFileUploadLazy,
    resource: resourcesRegistry.pageAdsTaskAddByTask,
    action: actionsRegistry.actionRead,
    selectedTabPath: '/ads-task',
  },
  {
    path: '/mma-task',
    component: MMALinkLazy,
    resource: resourcesRegistry.pageMmaTask,
    action: actionsRegistry.actionRead,
    selectedTabPath: '/mma-task',
    attachedPolicies: [activePoliciesRegistry.allowMmaTaskPageEdit],
  },
  {
    path: '/mma-task/generate-mma-banner',
    component: MMAConsentBannerCreation,
    resource: resourcesRegistry.pageMmaTaskGenerateMmaBanner,
    action: actionsRegistry.actionRead,
    selectedTabPath: '/mma-task',
    attachedPolicies: [activePoliciesRegistry.allowMmaTaskPageView],
  },
  {
    path: '/ads-task/:task/add',
    component: AdsTaskFileUploadLazy,
    resource: resourcesRegistry.pageAdsTask,
    action: actionsRegistry.actionRead,
    selectedTabPath: '/ads-task',
  },
  {
    path: '/ads-task/:task/:id/status',
    component: TaskStatusLazy,
    resource: resourcesRegistry.pageAdsTask,
    action: actionsRegistry.actionRead,
    selectedTabPath: '/ads-task',
  },
  {
    path: '/ads-task/:task',
    component: TaskCampaignLazy,
    resource: resourcesRegistry.pageAdsTask,
    action: actionsRegistry.actionRead,
    selectedTabPath: '/ads-task',
  },
  {        // @pbac-policy: allow_live_commerce_landing_page_view_access
    path: '/live-commerce',
    component: LiveCommerceLazy,
    resource: resourcesRegistry.pageLiveCommerce,
    action: actionsRegistry.actionRead,
    selectedTabPath: '/live-commerce',
    attachedPolicies: [activePoliciesRegistry.allowLiveCommerceLandingPageViewAccess],
  },
  {        // @pbac-policy: allow_live_commerce_templates_view_access
    path: '/live-commerce-templates',
    component: TemplatePresetsLazy,
    resource: resourcesRegistry.pageLiveCommerceTemplates,
    action: actionsRegistry.actionRead,
    selectedTabPath: '/live-commerce-templates',
    attachedPolicies: [activePoliciesRegistry.allowLiveCommerceTemplatesViewAccess],
  },
  {        // @pbac-policy: allow_live_commerce_template_create_preset_access
    path: '/live-commerce-template/create-preset',
    component: CreateTemplatePresetLazy,
    resource: resourcesRegistry.pageLiveCommerceTemplateCreatePreset,
    action: actionsRegistry.actionRead,
    selectedTabPath: '/live-commerce-templates',
    attachedPolicies: [activePoliciesRegistry.allowLiveCommerceTemplateCreatePresetAccess],
  },
  {        // @pbac-policy: allow_live_commerce_template_edit_access
    path: '/live-commerce-template/edit/:id',
    component: CreateTemplatePresetLazy,
    resource: resourcesRegistry.pageLiveCommerceTemplateEditId,
    action: actionsRegistry.actionRead,
    selectedTabPath: '/live-commerce-templates',
    attachedPolicies: [activePoliciesRegistry.allowLiveCommerceTemplateEditAccess],
  },
  {        // @pbac-policy: allow_live_commerce_campaigns_view_access
    path: '/live-commerce-campaigns',
    component: CampaignPresetsLazy,
    resource: resourcesRegistry.pageLiveCommerceCampaigns,
    action: actionsRegistry.actionRead,
    selectedTabPath: '/live-commerce-campaigns',
    attachedPolicies: [activePoliciesRegistry.allowLiveCommerceCampaignsViewAccess],
  },
  {
  // @pbac-policy: allow_live_commerce_campaign_edit_access 
    path: '/live-commerce-campaign/edit/:id',
    component: CreateCampaignPresetLazy,
    resource: resourcesRegistry.pageLiveCommerceCampaignEditId,
    action: actionsRegistry.actionRead,
    selectedTabPath: '/live-commerce-campaigns',
    attachedPolicies: [activePoliciesRegistry.allowLiveCommerceCampaignEditAccess],
  },
  {        // @pbac-policy: allow_live_commerce_campaign_creation_access
    path: '/live-commerce-campaign/create-preset',
    component: CreateCampaignPresetLazy,
    resource: resourcesRegistry.pageLiveCommerceCampaignCreatePreset,
    action: actionsRegistry.actionRead,
    selectedTabPath: '/live-commerce-campaigns',
    attachedPolicies: [activePoliciesRegistry.allowLiveCommerceCampaignCreationAccess],
  },
  {        // @pbac-policy: allow_live_commerce_streams_views_access
    path: '/live-commerce-streams',
    component: LiveStreamsLazy,
    resource: resourcesRegistry.pageLiveCommerceStreams,
    action: actionsRegistry.actionRead,
    selectedTabPath: '/live-commerce-streams',
    attachedPolicies: [activePoliciesRegistry.allowLiveCommerceStreamsViewsAccess],
  },
  { 
    // @pbac-policy: allow_live_commerce_streams_creation_access
    path: '/live-commerce-streams/create',
    component: CreateLiveStreamLazy,
    resource: resourcesRegistry.pageLiveCommerceStreamsCreate,
    action: actionsRegistry.actionRead,
    selectedTabPath: '/live-commerce-streams',
    attachedPolicies: [activePoliciesRegistry.allowLiveCommerceStreamsCreationAccess],
  },
  { 
    // @pbac-policy: allow_live_commerce_streams_upload_access
    path: '/live-commerce-streams/upload',
    component: LiveStreamBulkStreamCreationLazy,
    resource: resourcesRegistry.pageLiveCommerceStreamsUpload,
    action: actionsRegistry.actionRead,
    selectedTabPath: '/live-commerce-streams',
    attachedPolicies: [activePoliciesRegistry.allowLiveCommerceStreamsUploadAccess],
  },
  {        
    // @pbac-policy: allow_live_commerce_stream_update_access
    path: '/live-commerce-streams/update',
    component: LiveStreamBulkStreamUpdationLazy,
    resource: resourcesRegistry.pageLiveCommerceStreamsUpdate,
    action: actionsRegistry.actionRead,
    selectedTabPath: '/live-commerce-streams',
    attachedPolicies: [activePoliciesRegistry.allowLiveCommerceStreamUpdateAccess],
  },
  {        
    // @pbac-policy: allow_live_commerce_streams_id_access
    path: '/live-commerce-streams/:id',
    component: LiveStreamLazy,
    resource: resourcesRegistry.pageLiveCommerceStreamsId,
    action: actionsRegistry.actionRead,
    selectedTabPath: '/live-commerce-streams',
    attachedPolicies: [activePoliciesRegistry.allowLiveCommerceStreamsIdAccess],
  },
  {        
    // @pbac-policy: allow_live_commerce_streams_edit_access
    path: '/live-commerce-streams/edit/:id',
    component: CreateLiveStreamLazy,
    resource: resourcesRegistry.pageLiveCommerceStreamsEditId,
    action: actionsRegistry.actionRead,
    selectedTabPath: '/live-commerce-streams',
    attachedPolicies: [activePoliciesRegistry.allowLiveCommerceStreamsEditAccess],
  },
  {        
    // @pbac-policy: allow_live_commerce_real_estates_view_page_access
    path: '/live-commerce-real-estates',
    component: RealEstatePresetsLazy,
    resource: resourcesRegistry.pageLiveCommerceRealEstates,
    action: actionsRegistry.actionRead,
    selectedTabPath: '/live-commerce-real-estates',
    attachedPolicies: [activePoliciesRegistry.allowLiveCommerceRealEstatesViewPageAccess],
  },
  {        
    // @pbac-policy: allow_live_commerce_real_estate_create_preset_access
    path: '/live-commerce-real-estate/create',
    component: CreateRealEstatePresetLazy,
    resource: resourcesRegistry.pageLiveCommerceRealEstates,
    action: actionsRegistry.actionRead,
    selectedTabPath: '/live-commerce-real-estates',
    attachedPolicies: [activePoliciesRegistry.allowLiveCommerceRealEstateCreatePresetAccess],
  },
  {        // @pbac-policy: allow_live_streams_real_estate_presets_edit_access
    path: '/live-commerce-real-estate/edit/:id',
    component: CreateRealEstatePresetLazy,
    resource: resourcesRegistry.pageLiveCommerceRealEstateEditId,
    action: actionsRegistry.actionRead,
    selectedTabPath: '/live-commerce-real-estates',
    attachedPolicies: [activePoliciesRegistry.allowLiveStreamsRealEstatePresetsEditAccess],
  },
  {        // @pbac-policy: allow_live_commerce_banners_view_access
    path: '/live-commerce-banners',
    component: BannersLazy,
    resource: resourcesRegistry.pageLiveCommerceBanners,
    action: actionsRegistry.actionRead,
    selectedTabPath: '/live-commerce-banners',
    attachedPolicies: [activePoliciesRegistry.allowLiveCommerceBannersViewAccess],
  },
  {        // @pbac-policy: allow_live_commerce_banner_creation_access
    path: '/live-commerce-banner/create',
    component: UpsertBannersLazy,
    resource: resourcesRegistry.pageLiveCommerceBannerCreate,
    action: actionsRegistry.actionRead,
    selectedTabPath: '/live-commerce-banners',
    attachedPolicies: [activePoliciesRegistry.allowLiveCommerceBannerCreationAccess],
  },
  {        // @pbac-policy: allow_live_commerce_edit_banner_access
    path: '/live-commerce-banner/edit/:id',
    component: UpsertBannersLazy,
    resource: resourcesRegistry.pageLiveCommerceBannerEditId,
    action: actionsRegistry.actionRead,
    selectedTabPath: '/live-commerce-banners',
    attachedPolicies: [activePoliciesRegistry.allowLiveCommerceEditBannerAccess],
  },
  {        // @pbac-policy: allow_live_commerce_discounts_view_access
    path: '/live-commerce-discounts',
    component: DiscountsLazy,
    resource: resourcesRegistry.pageLiveCommerceDiscounts,
    action: actionsRegistry.actionRead,
    selectedTabPath: '/live-commerce-discounts',
    attachedPolicies: [activePoliciesRegistry.allowLiveCommerceDiscountsViewAccess],
  },
  {        // @pbac-policy: allow_live_commerce_offer_creation_access
    path: '/live-commerce-discounts/add',
    component: AddDiscountLazy,
    resource: resourcesRegistry.pageLiveCommerceDiscountsAdd,
    action: actionsRegistry.actionRead,
    selectedTabPath: '/live-commerce-discounts',
    attachedPolicies: [activePoliciesRegistry.allowLiveCommerceOfferCreationAccess],
  },
  {        // @pbac-policy: allow_live_commerce_discounts_upload_access
    path: '/live-commerce-discounts/upload',
    component: UploadDiscountLazy,
    resource: resourcesRegistry.pageLiveCommerceDiscountsUpload,
    action: actionsRegistry.actionRead,
    selectedTabPath: '/live-commerce-discounts',
    attachedPolicies: [activePoliciesRegistry.allowLiveCommerceDiscountsUploadAccess],
  },
  {        // @pbac-policy: allow_live_commerce_offer_id_access
    path: '/live-commerce-discounts/:offerId',
    component: AddDiscountLazy,
    resource: resourcesRegistry.pageLiveCommerceDiscountsOfferId,
    action: actionsRegistry.actionRead,
    selectedTabPath: '/live-commerce-discounts',
    attachedPolicies: [activePoliciesRegistry.allowLiveCommerceOfferIdAccess],
  },
  {
    path: '/campaign-dashboard',
    component: CampaignDashboard,
    resource: resourcesRegistry.pageCampaignDashboard,
    action: actionsRegistry.actionRead,
    selectedTabPath: '/campaign-dashboard',
  },
  {
    path: '/display-awareness/:id',
    component: DisplayAwareness,
    resource: resourcesRegistry.pageDisplayAwarenessId,
    action: actionsRegistry.actionRead,
    selectedTabPath: '/display-awareness',
  },
  {
    path: '/create-new-campaign',
    component: CreateNewCampaign,
    resource: resourcesRegistry.pageCreateNewCampaign,
    action: actionsRegistry.actionRead,
    selectedTabPath: '/create-new-campaign',
  },
  { // TODO: check with Raju before remove this route
    path: '/non-seller-portal',
    component: NonSellerPortal,
    resource: resourcesRegistry.pageNonSellerPortal,
    action: actionsRegistry.actionRead,
    selectedTabPath: '/non-seller-portal',
  },
];

export default pageRoutes;
